var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditCustomizationItem = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "M1.917 10.084h.816l5.032-5.032-.817-.816-5.031 5.031zm8.341-5.877L7.78 1.757 8.596.94A1.12 1.12 0 0 1 9.42.604q.489 0 .824.336l.816.817q.336.334.35.81.015.473-.32.808zM1.333 11.25a.56.56 0 0 1-.415-.168.56.56 0 0 1-.168-.415V9.019a.6.6 0 0 1 .175-.423l6.008-6.008 2.48 2.479-6.009 6.008a.58.58 0 0 1-.423.175zm6.023-6.606-.408-.408.817.816z"
})));
export default SvgEditCustomizationItem;